/**
 * Revoked-integrations banner state (TV1-2446 slice 7)
 *
 * A dedicated CDSE slice, separate from `SystemsIntegrationsState`, so the banner's own
 * subscription/registration lifecycle is independent of the connector catalog store.
 */

import type { RevokedIntegrationEntry } from './revokedIntegrations';
import { selectSortedRevokedIntegrations } from './revokedIntegrations';

export type RevokedIntegrationsBannerState = {
  entries: Record<string, RevokedIntegrationEntry>;
};

export const initialState: RevokedIntegrationsBannerState = {
  entries: {}
};

export const selectors = {
  /** Every revoked integration, of any kind, sorted by label. */
  selectRevokedIntegrations: ( state: RevokedIntegrationsBannerState ): RevokedIntegrationEntry[] =>
    selectSortedRevokedIntegrations( state.entries )
};
